export enum ChipType {
  yellow = "yellow",
  blue = "blue",
  default = "default"
}
